import produce from 'immer';
import { loginActions } from '../../../views/public/login/actions';
import {
  getUserInfo,
  getUserRefreshToken,
  getUserToken
} from '../../helpers/StorageUtils';

const initialState = {
  idToken: getUserToken(),
  refreshToken: getUserRefreshToken(),
  userInfo: getUserInfo(),
  isLoadingProfile: false,
};

const broadcastChannel = new BroadcastChannel('AUTH_CHANNEL');

const User = (state = initialState, action) => {
  const { type: actionType, payload } = action;
  switch (actionType) {
    case loginActions.LOGIN_SUCCESS:
      broadcastChannel.postMessage({ actionType });
      return produce(state, (draft) => {
        draft.idToken = payload.idToken;
        draft.refreshToken = payload.refreshToken;
      });
    case loginActions.LOGOUT_SUCCESS:
    case loginActions.TOKEN_EXPIRED_SUCCESS:
      broadcastChannel.postMessage({ actionType });
      return produce(state, (draft) => {
        draft.idToken = null;
        draft.refreshToken = null;
        draft.userInfo = null;
      });

    case loginActions.GET_USER_PROFILE:
      return produce(state, (draft) => {
        draft.isLoadingProfile = true;
        draft.actionType = actionType;
      });
    case loginActions.GET_USER_PROFILE_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoadingProfile = true;
        draft.userInfo = payload;
      });
    case loginActions.GET_USER_PROFILE_ERROR:
      return produce(state, (draft) => {
        draft.isLoadingProfile = false;
        draft.actionType = actionType;
      });

    default:
      return state;
  }
};

export default User;
